export const ELEMENT_UPDATE_PERMISSIONS = 'ELEMENT_UPDATE_PERMISSIONS';
export const ELEMENT_UPDATE_PERMISSIONS_ERROR = 'ELEMENT_UPDATE_PERMISSIONS_ERROR';
